import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { RoadmapApi } from '../roadmap-api';
import type { IGetListData } from '../../types/index';

@injectable()
export class RoadmapApiImpl extends PsHttpService implements RoadmapApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    previewMeta(meta: any) {
        return this.post<PatSnapCommonResponseData<{
            group: number,
            number: number
        }>>({
            url: '/roadmap/query/count',
            data: {
                q_meta: {
                    query: meta,
                },
            },
        }).then((res) => {
            return res.data as {
                group: number,
                number: number
            };
        });
    }

    create(title: string, meta: any) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/roadmap/',
            data: {
                title,
                q_meta: {
                    query: meta,
                },
            },
        }).then((res) => {
            return res.data as string;
        });
    }

    update(roadMapId: string, meta: any) {
        return this.post<PatSnapCommonResponseData<unknown>>({
            url: `/roadmap/${roadMapId}/update-query`,
            data: {
                q_meta: {
                    query: meta,
                },
            },
        }).then((res) => {
            return res.data;
        });
    }

    delete(roadMapId: string) {
        return this.request<PatSnapCommonResponseData<unknown>>({
            url: `/roadmap/${roadMapId}`,
            method: 'DELETE',
        }).then((res) => {
            return res.data;
        });
    }

    init() {
        return this.get<PatSnapCommonResponseData<number>>({
            url: '/roadmap/init',
        }).then((res) => {
            return res.data.roadmap_count;
        });
    }

    getList(params?: IGetListParams) {
        return this.get<PatSnapCommonResponseData<IGetListData>>({
            url: '/roadmap/list',
            params,
        }).then((res) => {
            return res.data as IGetListData
        })
    }
}
